var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 163,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.5 90s109.554-73.266 190-86.5c159.93-26.31 234.5 185.5 385 155C712.85 130.868 777.5 52 777.5 52",
    stroke: "#fff0",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzc5IiBoZWlnaHQ9IjE2MyIgdmlld0JveD0iMCAwIDc3OSAxNjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMyIgZD0iTTEuNSA5MC4wMDAxQzEuNSA5MC4wMDAxIDExMS4wNTQgMTYuNzM0MyAxOTEuNSAzLjUwMDEyQzM1MS40MyAtMjIuODEgNDI2IDE4OSA1NzYuNSAxNTguNUM3MTIuODUgMTMwLjg2OCA3NzcuNSA1Mi4wMDAyIDc3Ny41IDUyLjAwMDIiIHN0cm9rZT0iI2ZmZjAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWRhc2hhcnJheT0iNCA0Ii8+Cjwvc3ZnPgo=";
export { SvgWave as ReactComponent };